import { DateTime } from 'luxon';

/** Whole days from today (household zone) to an ISO date; today = 0, past = negative. */
export function daysUntil(iso: string, zone: string): number {
  const today = DateTime.now().setZone(zone).startOf('day');
  return Math.round(DateTime.fromISO(iso, { zone }).startOf('day').diff(today, 'days').days);
}

/** The next occurrence of a birthday (this year or next) and days until it. */
export function nextBirthday(birthday: string, zone: string): { iso: string; days: number } {
  const today = DateTime.now().setZone(zone).startOf('day');
  let next = DateTime.fromISO(birthday, { zone }).set({ year: today.year });
  if (next < today) next = next.plus({ years: 1 });
  return { iso: next.toISODate()!, days: Math.round(next.diff(today, 'days').days) };
}

/** "today" / "tomorrow" / "in 12 days" / "42 days ago". */
export function untilLabel(days: number): string {
  if (days === 0) return 'today';
  if (days === 1) return 'tomorrow';
  if (days === -1) return 'yesterday';
  return days > 0 ? `${days} days` : `${-days} days ago`;
}
